import * as momentTz from "moment-timezone";
import {IReportData} from "./report-data-interface";
import { ColumnModel, TableModel } from "gaming-component-ngx-common";

export class BreachData {

  constructor(public venueId: string,
              public licenceId: string,
              public licenceName: string,
              public licenceType: string,
              public isActive: boolean,
              public breachType: string,
              public dateDetected: string,
              public dateDetectedSimple: string,
              public breachedDevices: number,
              public totalDevices: number,
              public turnOver: number,
              public gamesPlayed: number) {
  }

  get breached(): string {
    return '' + this.breachedDevices + ' of ' + this.totalDevices;
  }
}

// tslint:disable-next-line:max-classes-per-file
export class BreachListFilters { // Filter info for CSV header
  constructor(
    public searchString?: string,
    public tolerance?: number,
    public btype?: string,
    public licenceType?: string,
    public dateRange?: string,
    public venueId?: string,
  ) {}
}

// tslint:disable-next-line:max-classes-per-file
export class BreachListData implements IReportData {

  public tableData: TableModel;
  public filters: BreachListFilters; // Filter info for CSV header

  constructor() {
    this.filters = new BreachListFilters(); // Filter info for CSV header
    this.tableData = new TableModel();
    this.tableData.columns = new Array<ColumnModel>();
    this.tableData.allRows = new Array<BreachData>();
    this.tableData.useFilteredRows = true;
    this.tableData.filteredRows = new Array<BreachData>();
    this.setColumns();
  }

  public setColumns() {
    this.tableData.columns.push(new ColumnModel("licenceId", "licenceId",
      "Licence Number", true, "", null, null, ""));
    this.tableData.columns.push(new ColumnModel("licenceName", "licenceName", "Licence Name",
      true, "", "left aligned", null, ""));
    this.tableData.columns.push(new ColumnModel("breachType", "breachType", "Breach Type",
      true, "", "left aligned", null, ""));
    this.tableData.columns.push(new ColumnModel("dateDetected", "dateDetectedSimple", "Date Detected",
      true, "", "left aligned", null, ""));
    this.tableData.columns.push(new ColumnModel("breached", "breachedDevices", "Breached",
      true, "", "left aligned", null, ""));
    this.tableData.columns.push(new ColumnModel("turnOver", "turnOver", "Sum T/O($)",
      true, "", "left aligned", null, ""));
    this.tableData.columns.push(new ColumnModel("gamesPlayed", "gamesPlayed", "Games Played",
      true, "", "left aligned", null, ""));

    // default sorting
    this.tableData.columns[3].isSortSelected = true;
    this.tableData.columns[3].sortDirection = "descending";
    this.tableData.secondarySortColumn = "licenceNumber";
    this.tableData.secondarySortDirection = "ascending";
    this.tableData.secondarySortType = null;
  }

  public toCSV() {
    this.tableData.csvHeader = this.generateCsvHeader(); // Filter info for CSV header
    return this.tableData.toCSV();
  }

  public generateCsvHeader() { // Filter info for CSV header
    let header = `Search,Filter Breach Type,Date Range,Timestamp\n`;
    header += `${this.filters.searchString || '-'},`;
    header += `${this.filters.btype || '-'},`;
    header += `${this.filters.dateRange || '-'},`;
    header += `${momentTz().tz("Australia/Sydney").format("DD/MM/YYYY h:mmA")}`;
    header += `\n`;
    return header;
  }
}



// WEBPACK FOOTER //
// ./client/app/models/breach-list-model.ts